module.exports = __webpack_public_path__ + "assets/media/evening.73615c88.mp3";